module.exports = __webpack_public_path__ + "img/yj2.f9818441.png";